import React, { useState, useEffect } from 'react';
import { Button } from 'primereact/button';

interface BackToTopButtonProps {
  scrollThreshold?: number;
}

const BackToTopButton: React.FC<BackToTopButtonProps> = ({ 
  scrollThreshold = 300 
}) => {
  const [isVisible, setIsVisible] = useState<boolean>(false);
  const [isAnimating, setIsAnimating] = useState<boolean>(false);

  // Check scroll position and toggle visibility
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > scrollThreshold) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    
    return () => window.removeEventListener('scroll', handleScroll);
  }, [scrollThreshold]);

  const scrollToTop = () => {
    setIsAnimating(true);
    
    // Smooth scroll to top
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
    
    // Reset animation state after scroll completes
    setTimeout(() => {
      setIsAnimating(false);
    }, 500);
  };

  return (
    <Button
      icon="pi pi-arrow-up"
      onClick={scrollToTop}
      className={`back-to-top-button ${isVisible ? 'visible' : 'hidden'} ${isAnimating ? 'animating' : ''}`}
      aria-label="Back to top"
    />
  );
};

export default BackToTopButton;
